var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingsIcone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.999H23.1905",
    stroke: "#1165BA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6802 19V1.78261C13.6802 1.57505 13.5967 1.37599 13.4481 1.22922C13.2995 1.08245 13.0979 1 12.8877 1H3.37748C3.16729 1 2.96571 1.08245 2.81708 1.22922C2.66846 1.37599 2.58496 1.57505 2.58496 1.78261V19",
    stroke: "#1165BA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6049 18.9999V8.04335C21.6049 7.83579 21.5214 7.63673 21.3728 7.48996C21.2241 7.3432 21.0226 7.26074 20.8124 7.26074H13.6797",
    stroke: "#1165BA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75488 4.91309H8.92496",
    stroke: "#1165BA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33984 11.1729H10.5099",
    stroke: "#1165BA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75488 15.0869H8.92496",
    stroke: "#1165BA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8506 15.0869H18.4356",
    stroke: "#1165BA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8506 11.1729H18.4356",
    stroke: "#1165BA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingsIcone);
export default __webpack_public_path__ + "static/media/Buildings-icone.bb2cac4dd55d69495db31129bacce21c.svg";
export { ForwardRef as ReactComponent };